import './App.css';
import logo from './assets/logo.png';
import background from './assets/background.webp';
import LinkedInIcon  from '@mui/icons-material/LinkedIn';
import EmailIcon  from '@mui/icons-material/Email';

function App() {
  return (
    <>
    <div className="container-fluid d-flex flex-column align-items-center justify-content-center min-vh-100" 
     style={{ 
       backgroundImage: `url(${background})`, 
       backgroundSize: 'cover', 
       backgroundPosition: 'center', 
       backgroundRepeat: 'no-repeat',
       backgroundAttachment: 'fixed' // Improves UX for large images
     }}>    
      <header className="py-3">
        <img src={logo} className="img-fluid" alt="Geraint Homes Logo" loading="lazy" style={{ maxWidth: '250px', height: 'auto' }} />
      </header>
      <main className="p-4 rounded shadow-lg" style={{ maxWidth: '600px', background: 'rgba(0, 0, 0, 0.5)' }}>
        <div className="text-white text-justify fs-5">
          <h1 className="text-white">Geraint Homes LTD</h1>
          <p className="text-white">Incorporated on 24 April 2013.</p>
          <blockquote className="blockquote border-start border-4 border-light ps-3 mb-3 fst-italic">
            <p>To contact:<br />Anthony Leigh <br />Mobile/WhatsApp: +447990750849 <br />
            <EmailIcon />  Email: <a href="mailto:anthony@gerainthomes.co.uk" className="text-white text-decoration-underline">anthony@gerainthomes.co.uk</a> <br />
            <LinkedInIcon /> <a href="https://linkedin.com/in/anthonycharlesleigh" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-underline">linkedin.com/in/anthonycharlesleigh            </a>
            </p>
          </blockquote>
          <blockquote className="blockquote border-start border-4 border-light ps-3 mb-3 fst-italic">
            <p>Registered Office: <br />Geraint Homes LTD<br />Ynys Cyngar, Morfa Bychan, Porthmadog, <br />Gwynedd, North Wales, LL49 9UU, UK.</p>
            <p>Company No: 08502249<br />Vat Reg: GB 352801319</p>            
          </blockquote>
        </div>
      </main>      
      <footer className="mt-4">
        <p className="text-white">
          Managed by <span className="fw-bold">Animesh</span> | Hosted by <a href="https://abhianni.com" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-underline"><span className="fw-bold">Abhianni Group</span></a>     
        </p>
      </footer>
    </div> 
    </>  

  );
}

export default App;
